<template>
  <div class="routes py-3">
    <div>
      <v-card class="mx-auto">
        <v-toolbar color="#E21A22" dark>
          <v-btn icon @click="prev">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{ dateFormat }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="next">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <v-list three-line v-if="!routes.length">
          <template>
            <v-list-item-content>
              <v-list-item-title>
                <div class="px-5">{{ message }}</div>
              </v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list>
        <GmapMap
          ref="map"
          v-if="routes.length"
          :center="{ lat: 33.9190068, lng: -118.1200275 }"
          :position="google && new google.maps.LatLng(33.9190068, -118.1200275)"
          :zoom="14"
          :key="id"
          style="width: 100%; height: 400px"
          class="mx-auto"
        >
        </GmapMap>
        <v-list three-line v-if="routes.length" class="py-0">
          <template v-for="(item, index) in customersActivos">
            <v-divider :key="'d-' + index"></v-divider>
            <v-list-item
              :key="'c-' + index"
              @click="muestraRuta(item.__originalIndex)"
              :class="'class' in item ? item.class : ''"
              :style="
                'user_id' in item && item.user_id > 0
                  ? 'border: 2px dashed red;'
                  : ''
              "
            >
              <v-list-item-avatar :key="'letter-' + index" color="#EA4335">
                <span class="white--text headline text-center mx-auto">{{
                  letters[index]
                }}</span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  v-html="
                    '<strong>' +
                    item.businessName +
                    ' - ' +
                    item.accountNumber +
                    '</strong> (' +
                    item.route +
                    ')'
                  "
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.serviceAddress"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-html="item.contactPerson + ' - ' + item.phoneNumber"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-if="item.manifestNumber"
                  v-html="'Manifest Number: ' + item.manifestNumber"
                  class="font-weight-black"
                ></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-avatar :key="'containers-' + index" color="green">
                <span class="white--text headline text-center mx-auto">{{
                  item.numContainers
                }}</span>
              </v-list-item-avatar>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </div>
    <v-row justify="center">
      <v-dialog v-model="dialogNote" max-width="600" scrollable>
        <v-card class="black--text">
          <v-card-title>
            Customer Details
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogNote = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="black--text">
            <p>
              <strong>Account number:</strong> {{ route.accountNumber }}
            </p>
            <p>
              <strong>Business name:</strong> {{ route.businessName }}
            </p>
            <p><strong>Route:</strong> {{ route.route }}</p>
            <p>
              <strong>Service address:</strong>
              {{ route.serviceAddress }}
            </p>
            <p>
              <strong>Days and hours of operation:</strong><br />
              <span
                v-for="(dh, ind) in route.daysAndHoursOfOperation"
                :key="'dialog-dh-' + ind"
                >- {{ dh.name }}<br
              /></span>
            </p>
            <p>
              <strong>Containers at location:</strong><br />
              <span
                v-for="(cn, ind) in route.containersAtLocation"
                :key="'dialog-cn-' + ind"
                >- {{ cn.container }}<br
              /></span>
            </p>
            <template v-if="route.dropOffs && route.dropOffs.length > 0">
              <p>
                <strong>Drop-Off Containers:</strong><br />
                <span
                  v-for="(cn, ind) in route.dropOffs"
                  :key="'dialog-dropoff-' + ind"
                  >- {{ cn.extra }} ({{ cn.pivot.qty }})<br
                /></span>
              </p>
            </template>
            <p><strong>E-mail:</strong> {{ route.email }}</p>
            <p>
              <strong>Phone number:</strong> {{ route.phoneNumber }}
            </p>
            <p>
              <strong>Contact person at clinic:</strong>
              {{ route.contactPerson }}
            </p>
            <template v-if="route.notes">
              <div class="mb-3">
                <strong>Notes:</strong>
                <div>{{ route.notes }}</div>
              </div>
            </template>
            <template v-if="route.notes_to_driver">
              <div class="mb-3">
                <strong>Notes From Office:</strong>
                <div>{{ route.notes_to_driver }}</div>
              </div>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="dialogNote = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#1B6BAA">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ route.businessName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              v-if="route"
              icon
              dark
              aria-label="View customer details"
              @click.stop="dialogNote = true"
            >
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
            <v-toolbar-items> </v-toolbar-items>
          </v-toolbar>
          <GmapMap
            v-if="route"
            :center="center"
            :zoom="14"
            style="width: 100%; height: 400px"
            class="mx-auto"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              @click="center = m.position"
            />
          </GmapMap>
          <visit-attempts
            v-if="route && route.routeschedule_id > 0"
            :key="route.routeschedule_id"
            :visit-id="route.routeschedule_id"
            :image-base="imageUrl"
            @reset="visitReset"
          />
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step
                :complete="e1 > 1"
                step="1"
                @click="
                  realStep = e1;
                  e1 = 1;
                "
                >Start Route</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" step="2"
                >Check In</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 3" step="3"
                >Prepare Ticket</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 4" step="4"
                >Signatures & Manifest</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step step="5">Complete Route</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1" class="">
                <v-card class="mb-6 elevation-5 mx-auto" outlined>
                  <v-toolbar color="#E21A22" dark>
                    <v-toolbar-title>Details</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <div class="red darken-1 px-2" v-if="route.notes_to_driver">
                      <p class="white--text">
                        <strong>Notes From Office:</strong>
                        {{ route.notes_to_driver }}
                      </p>
                    </div>
                    <p>
                      <strong>Account number:</strong> {{ route.accountNumber }}
                    </p>
                    <p>
                      <strong>Business name:</strong> {{ route.businessName }}
                    </p>
                    <p><strong>Route:</strong> {{ route.route }}</p>
                    <p>
                      <strong>Service address:</strong>
                      {{ route.serviceAddress }}
                    </p>
                    <p>
                      <strong>Days and hours of operation:</strong><br />
                      <span
                        v-for="(dh, ind) in route.daysAndHoursOfOperation"
                        :key="'dh-' + ind"
                        >- {{ dh.name }}<br
                      /></span>
                    </p>
                    <p>
                      <strong>Containers at location:</strong><br />
                      <span
                        v-for="(cn, ind) in route.containersAtLocation"
                        :key="'cn-' + ind"
                        >- {{ cn.container }}<br
                      /></span>
                    </p>
                    <template v-if="route.dropOffs && route.dropOffs.length">
                      <p>
                        <strong>Drop-Off Containers:</strong><br />
                        <span
                          v-for="(cn, ind) in route.dropOffs"
                          :key="'cn-' + ind"
                          >- {{ cn.extra }} ({{ cn.pivot.qty }})<br
                        /></span>
                      </p>
                    </template>
                    <p><strong>E-mail:</strong> {{ route.email }}</p>
                    <p>
                      <strong>Phone number:</strong> {{ route.phoneNumber }}
                    </p>
                    <p>
                      <strong>Contact person at clinic:</strong>
                      {{ route.contactPerson }}
                    </p>
                    <p><strong>Notes:</strong> {{ route.notes }}</p>
                  </v-card-text>
                </v-card>
                <div class="text-center">
                  <v-btn
                    color="primary"
                    @click="startRoute"
                    class="mx-auto"
                    :loading="loading"
                    :disabled="loading"
                    v-if="realStep == 1"
                  >
                    Start Route
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="e1 = realStep"
                    class="mx-auto"
                    v-else
                  >
                    Resume
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card class="mb-6 elevation-5 mx-auto" outlined>
                  <v-toolbar color="#E21A22" dark>
                    <v-toolbar-title>Activities</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-list-item-title class="headline mb-1"
                      >Step 2</v-list-item-title
                    >
                    <p class="text-center">
                      Check In at customer service address. If you need driving
                      directions, please press Directions.
                    </p>
                    <p class="text-center">
                      If upon arrival the business is closed, please press
                      Closed to take a picture and complete the route.
                    </p>
                    <div class="text-center">
                      <v-btn
                        color="blue mt-5 mb-5 mr-5"
                        class="white--text"
                        @click="directions"
                      >
                        Directions
                      </v-btn>
                      <v-btn
                        color="green mt-5 mb-5"
                        class="white--text"
                        :loading="loading2"
                        :disabled="loading2"
                        @click="checkIn"
                      >
                        Check In
                      </v-btn>
                      <v-btn
                        color="red mt-5 mb-5"
                        class="white--text"
                        :loading="loading5"
                        :disabled="loading5"
                        @click="closed"
                      >
                        Closed
                      </v-btn>
                      <input
                        ref="camera"
                        v-show="false"
                        type="file"
                        accept="image/*"
                        @change="addPicture"
                        capture="camera"
                        id="camera"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-card class="mb-6 elevation-5 mx-auto" outlined>
                  <v-toolbar color="#E21A22" dark>
                    <v-toolbar-title>Activities</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-list-item-title class="headline mb-1"
                      >Step 3</v-list-item-title
                    >
                    <!--
            <v-list-group :value="false">
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>Add Extras</v-list-item-title>
                    </v-list-item-content>
                </template>
                <v-list-group no-action sub-group :value="false" v-for="(item, index) in extras" :key="'extra-' + index">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.type }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                        <v-list-item v-for="(i, ind) in item.extras"
                          :key="'ex-' + ind"
                        >
                          <v-list-item-content>
                            <v-row>
                                <v-switch v-model="i.status" :label="i.extra" class="ml-5"></v-switch>
                                <v-select v-if="i.status" :items="qtys" label="Qty" v-model="i.qty" solo></v-select>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                    </v-list-group>
            </v-list-group>
            -->
                    <div class="text-center mb-3">
                      <h3>Containers at Location</h3>
                      <template
                        v-for="(contenedor, ind) in route.containersAtLocation"
                      >
                        <div :key="'contenedor-' + ind">
                          {{ contenedor.container }}
                        </div>
                      </template>
                    </div>
                    <template v-if="route.dropOffs && route.dropOffs.length">
                      <div class="text-center mb-3">
                        <h3>Drop-Off Containers</h3>
                        <template v-for="(contenedor, ind) in route.dropOffs">
                          <div :key="'dropoff-' + ind">
                            {{ contenedor.extra }} ({{ contenedor.pivot.qty }})
                          </div>
                        </template>
                      </div>
                    </template>
                    <div class="text-center">
                      <v-btn
                        color="success"
                        @click="assign"
                        class="mx-auto mr-2 mt-2"
                      >
                        Assign
                      </v-btn>
                      <v-btn
                        color="warning"
                        @click="pickup"
                        class="mx-auto mr-2 mt-2"
                      >
                        PickUp
                      </v-btn>
                      <v-btn
                        color="info"
                        @click="qrextras"
                        class="mx-auto mr-2 mt-2"
                      >
                        Extras
                      </v-btn>
                      <v-btn
                        color="success"
                        @click="qrmanualassign"
                        class="mx-auto mr-2 mt-2"
                      >
                        Manual Assign
                      </v-btn>
                      <v-btn
                        color="warning"
                        @click="qrmanualpickup"
                        class="mx-auto mr-2 mt-2"
                      >
                        Manual Pick Up
                      </v-btn>
                      <v-btn
                        color="info"
                        @click="qrmanualextras"
                        class="mx-auto mr-2 mt-2"
                      >
                        Manual Extras
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
                <div class="text-center mb-5">
                  <v-btn
                    color="red mt-5 mb-5"
                    class="white--text"
                    :loading="loading5"
                    :disabled="loading5"
                    @click="closed"
                  >
                    Closed
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="addExtras"
                    :loading="loading3"
                    :disabled="loading3"
                    class="mx-auto ml-2"
                  >
                    Continue
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-card class="mb-6 elevation-5 mx-auto" outlined>
                  <v-toolbar color="#E21A22" dark>
                    <v-toolbar-title>Signatures & Manifest</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <div v-if="[470, 613, 614].includes(route.id)">
                      <v-list-item-title class="headline mb-5"
                        >Weekly Manifest Data</v-list-item-title
                      >
                      <div class="caption">
                        <strong>Start Date</strong>
                      </div>
                      <v-date-picker
                        v-model="weekly_start"
                        color="green lighten-1"
                        header-color="primary"
                      ></v-date-picker>
                      <div class="caption">
                        <strong>End Date</strong>
                      </div>
                      <v-date-picker
                        v-model="weekly_end"
                        color="green lighten-1"
                        header-color="primary"
                      ></v-date-picker>
                      <v-text-field
                        label="MWS #"
                        v-model="weekly_mws"
                      ></v-text-field>
                    </div>
                    <v-list-item-title class="headline"
                      >Notes to Office</v-list-item-title
                    >
                    <v-textarea
                      v-model="notes"
                      class="px-4"
                      auto-grow
                    ></v-textarea>
                    <v-list-item-title class="headline mb-1"
                      >Driver's signature</v-list-item-title
                    >
                    <div class="caption">
                      <strong>Please sign</strong>
                    </div>
                    <VueSignaturePad
                      width="320px"
                      height="300px"
                      id="driverSignature"
                      ref="driverSignature"
                      class="mx-auto elevation-5 my-5"
                    />
                    <v-btn
                      v-if="$store.getters.signature"
                      color="success"
                      @click="driverSign"
                      class="mb-5 mr-3"
                    >
                      Sign
                    </v-btn>
                    <v-btn color="gray" @click="undoDriver" class="mb-5">
                      Undo signature
                    </v-btn>
                    <v-list-item-title class="headline mb-1"
                      >Customer's signature</v-list-item-title
                    >
                    <div class="caption">
                      <strong>Please sign</strong>
                    </div>
                    <VueSignaturePad
                      id="customerSignature"
                      width="320px"
                      height="300px"
                      ref="customerSignature"
                      class="mx-auto elevation-5 my-5"
                    />
                    <v-text-field
                      label="Customer's Name"
                      v-model="customerName"
                    ></v-text-field>
                    <v-text-field
                      label="Customer's Last Name"
                      v-model="customerLastName"
                    ></v-text-field>
                    <v-btn color="gray" @click="undoCustomer" class="mb-5">
                      Undo signature
                    </v-btn>
                  </v-card-text>
                </v-card>
                <div class="text-center">
                  <v-btn
                    color="gray"
                    @click="editManifest"
                    class="mx-auto"
                    :loading="loading6"
                    :disabled="loading6"
                  >
                    Add Extras
                  </v-btn>
                  &nbsp;
                  <v-btn
                    color="red mt-5 mb-5"
                    class="white--text"
                    :loading="loading5"
                    :disabled="loading5"
                    @click="closed"
                  >
                    Closed
                  </v-btn>
                  &nbsp;
                  <v-btn
                    color="primary"
                    @click="send"
                    class="mx-auto"
                    :loading="loading4"
                    :disabled="loading4"
                  >
                    Continue
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="5">
                <v-card class="mb-6 elevation-5 mx-auto" outlined>
                  <v-toolbar color="#E21A22" dark>
                    <v-toolbar-title>Completed Route</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <div class="text-center">
                      <p v-if="route.status == 'Completed'">
                        You have completed this route.
                      </p>
                      <p v-if="route.manifestNumber" class="font-weight-black">
                        Manifest Number: {{ route.manifestNumber }}
                      </p>
                      <div
                        class="text-center"
                        v-if="
                          route.status == 'Completed' && route.allowEdit == 1
                        "
                      >
                        <v-btn
                          color="primary"
                          @click="editManifest"
                          class="mx-auto"
                          :loading="loading6"
                          :disabled="loading6"
                        >
                          Edit Manifest
                        </v-btn>
                      </div>
                      <p v-if="route.status == 'Closed'">
                        The business was closed as shown in the following
                        picture.
                      </p>
                      <v-img
                        v-if="route.status == 'Closed'"
                        :src="imageUrl + route.image"
                      ></v-img>
                      <v-btn
                        color="primary"
                        @click="nextRoute"
                        class="mx-auto"
                        v-if="
                          routes.lenght &&
                          parseFloat(routeIndex) + 1 <
                            routes[0].customers.length
                        "
                      >
                        Next Route
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<style scoped>
.onroute {
  background: #e3f2fd;
}

.checkin {
  background: #bbdefb;
}

.extrasnotes {
  background: #90caf9;
}

.completed {
  background: #42a5f5;
}

.closed {
  background: #f44336;
}
</style>
<script>
import { gmapApi } from "vue2-google-maps";
import VisitAttempts from "@/components/VisitAttempts.vue";

export default {
  components: { VisitAttempts },
  data: () => ({
    qtys: [],
    e1: 1,
    id: 0,
    realStep: 1,
    routes: [],
    mapsLoaded: false,
    route: "",
    routeIndex: "",
    center: "",
    points: [],
    markers: [],
    message: "",
    dialog: false,
    dialogNote: false,
    letters: [
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "X",
      "Y",
      "Z",
    ],
    dateFormat: "",
    date: "",
    notes: "",
    location: [],
    extras: [],
    driverSignature: "",
    customerSignature: "",
    customerName: "",
    customerLastName: "",
    picture: "",
    loading: false,
    loading2: false,
    loading3: false,
    loading4: false,
    loading5: false,
    loading6: false,
    editManifestOp: false,
    weekly_start: "",
    weekly_end: "",
    weekly_mws: "",
    clockIn: false,
    assignmentVehicle: false,
  }),
  computed: {
    google: gmapApi,
    customersActivos() {
      if (!this.routes || !this.routes[0] || !this.routes[0].customers) {
        return [];
      }

      return this.routes[0].customers
        .map((item, index) => ({
          ...item,
          __originalIndex: index,
        }))
        .filter((item) => item.temporarily_suspended == 0);
    },
    hasRouteNotes() {
      const route = this.route;

      return !!(
        route &&
        (route.notes ||
          route.notes_to_driver ||
          (route.dropOffs && route.dropOffs.length > 0))
      );
    },
    imageUrl: function () {
      if (process.env.NODE_ENV == "development") {
        return "http://prima.test/storage/";
      } else {
        return "https://primawm.com/storage/";
      }
    },
  },
  watch: {
    date: function () {
      this.dateFormat = this.$moment(this.date).format("dddd, MMMM Do, YYYY");
    },
    e1: function (val) {
      var este = this;
      if (val == 4) {
        setTimeout(function () {
          este.$refs.driverSignature.resizeCanvas();
          este.$refs.customerSignature.resizeCanvas();
          este.$refs.customerSignature.clearSignature();
        }, 500);
        setTimeout(function () {
          este.getSignatures();
        }, 1000);
      }
    },
  },
  methods: {
    visitReset() {
      this.route.status = "Pending";
      this.route.class = "";
      this.route.manifestNumber = null;
      this.route.image = null;
      this.e1 = 1;
      this.realStep = 1;
      this.editManifestOp = false;
      this.driverSignature = "";
      this.customerSignature = "";
      this.customerName = "";
      this.customerLastName = "";
      this.$route.params.route_back = -1;
      if (this.$refs.driverSignature) this.$refs.driverSignature.clearSignature();
      if (this.$refs.customerSignature) this.$refs.customerSignature.clearSignature();
    },
    assign: function () {
      this.$store.commit("selectRoute", this.routeIndex);
      this.$store.commit(
        "customer_id",
        this.routes[0].customers[this.routeIndex].id,
      );
      this.$store.commit(
        "route_id",
        this.routes[0].customers[this.routeIndex].routeschedule_id,
      );
      //this.$router.push({name: "Assign", params:{route_back: this.routeIndex}});
      this.$router.push({
        name: "Assign",
        params: { route_back: this.route.id },
      });
    },
    pickup: function () {
      this.$store.commit("selectRoute", this.routeIndex);
      this.$store.commit(
        "customer_id",
        this.routes[0].customers[this.routeIndex].id,
      );
      this.$store.commit(
        "route_id",
        this.routes[0].customers[this.routeIndex].routeschedule_id,
      );
      //this.$router.push({name: "Pickup", params:{route_back: this.routeIndex}});
      this.$router.push({
        name: "Pickup",
        params: { route_back: this.route.id },
      });
    },
    qrextras: function () {
      this.$store.commit("selectRoute", this.routeIndex);
      this.$store.commit(
        "customer_id",
        this.routes[0].customers[this.routeIndex].id,
      );
      this.$store.commit(
        "route_id",
        this.routes[0].customers[this.routeIndex].routeschedule_id,
      );
      //this.$router.push({name: "Extras", params:{route_back: this.routeIndex}});
      this.$router.push({
        name: "Extras",
        params: { route_back: this.route.id },
      });
    },
    qrmanualextras: function () {
      this.$store.commit("selectRoute", this.routeIndex);
      this.$store.commit(
        "customer_id",
        this.routes[0].customers[this.routeIndex].id,
      );
      this.$store.commit(
        "route_id",
        this.routes[0].customers[this.routeIndex].routeschedule_id,
      );
      //this.$router.push({name: "ManualExtras", params:{route_back: this.routeIndex}});
      this.$router.push({
        name: "ManualExtras",
        params: { route_back: this.route.id },
      });
    },
    qrmanualassign: function () {
      this.$store.commit("selectRoute", this.routeIndex);
      this.$store.commit(
        "customer_id",
        this.routes[0].customers[this.routeIndex].id,
      );
      this.$store.commit(
        "route_id",
        this.routes[0].customers[this.routeIndex].routeschedule_id,
      );
      //this.$router.push({name: "ManualExtras", params:{route_back: this.routeIndex}});
      this.$router.push({
        name: "ManualAssign",
        params: { route_back: this.route.id },
      });
    },
    qrmanualpickup: function () {
      this.$store.commit("selectRoute", this.routeIndex);
      this.$store.commit(
        "customer_id",
        this.routes[0].customers[this.routeIndex].id,
      );
      this.$store.commit(
        "route_id",
        this.routes[0].customers[this.routeIndex].routeschedule_id,
      );
      //this.$router.push({name: "ManualExtras", params:{route_back: this.routeIndex}});
      this.$router.push({
        name: "ManualPickup",
        params: { route_back: this.route.id },
      });
    },
    nextRoute: function () {
      this.muestraRuta(parseInt(this.routeIndex) + 1);
      window.console.log("Next Route");
    },
    directions: function () {
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" +
          this.route.location[0].lat +
          "," +
          this.route.location[0].lng,
      );
    },
    getExtras: function () {
      var este = this;
      var datos = {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
      };
      este.$http
        .post(este.$api + "getExtras", datos)
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            console.log("Extras");
            este.extras = response.data.data.extras;
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: "There was an error. Please try again.",
            };
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
    getSignatures: function () {
      var este = this;
      var laurl = "getSignatures";
      var datos = "";
      datos = {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
        routeschedule_id: este.route.routeschedule_id,
      };
      este.$http.post(este.$api + laurl, datos).then(function (response) {
        if (response.status == 200 && response.data.status == "ok") {
          if (response.data.driverSignature != "") {
            este.$refs.driverSignature.fromDataURL(
              response.data.driverSignature,
            );
          }
          if (response.data.customerSignature != "") {
            este.$refs.customerSignature.fromDataURL(
              response.data.customerSignature,
            );
          }
          if (response.data.contactPersonAtClinic != "") {
            este.customerName = response.data.contactPersonName;
            este.customerLastName = response.data.contactPersonLastName;
          }
        }
      });
    },
    addExtras: function () {
      var este = this;
      este.loading3 = true;
      // este
      //   .$getLocation()
      //   .then((coordinates) => {
      //     console.log(coordinates);
      //     este.location = coordinates;
      var laurl = "addExtras";
      var datos = "";
      datos = {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
        routeschedule_id: este.route.routeschedule_id,
        // location: este.location,
        extras: este.extras,
        containers: este.route.containersAtLocation,
      };
      este.$http
        .post(este.$api + laurl, datos)
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            console.log("Extras Ready");
            este.routes[0].customers[este.routeIndex].status = "Extras / Notes";
            este.routes[0].customers[este.routeIndex].class = "extrasnotes";
            este.e1 = 4;
            este.$route.params.route_back = -1;
            este.loading3 = false;
            window.console.log(response.status);
            este.getExtras();
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: "There was an error. Please try again later.",
            };
            este.$store.commit("msgMuestra", mensaje);
            este.loading3 = false;
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          este.loading3 = false;
          window.console.log(err);
        });
      // })
      // .catch(function (err) {
      //   var mensaje = {
      //     color: "red",
      //     timeout: 5000,
      //     message: "We couldn't get your location. Please try again.",
      //   };
      //   este.loading3 = false;
      //   este.$store.commit("msgMuestra", mensaje);
      //   window.console.log(err);
      // });
    },
    isSignatureBlank(signaturePadRef) {
      try {
        var canvas = signaturePadRef.$el.querySelector('canvas');
        if (!canvas) return true;
        var ctx = canvas.getContext('2d');
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var bgR = pixels[0], bgG = pixels[1], bgB = pixels[2], bgA = pixels[3];
        var drawn = 0;
        for (var i = 4; i < pixels.length; i += 4) {
          if (pixels[i] !== bgR || pixels[i + 1] !== bgG || pixels[i + 2] !== bgB || pixels[i + 3] !== bgA) {
            if (++drawn >= 50) return false;
          }
        }
        return true;
      } catch (e) {
        return false;
      }
    },
    driverSign() {
      this.$refs.driverSignature.fromDataURL(this.$store.getters.signature);
    },
    undoDriver() {
      this.$refs.driverSignature.undoSignature();
    },
    undoCustomer() {
      this.$refs.customerSignature.undoSignature();
    },
    prev: function () {
      this.$route.params.route_back = -1;
      this.date = this.$moment(this.date)
        .subtract(1, "day")
        .format("YYYY-MM-DD");
      this.show();
    },
    next: function () {
      this.$route.params.route_back = -1;
      this.date = this.$moment(this.date).add(1, "day").format("YYYY-MM-DD");
      this.show();
    },
    send() {
      var este = this;
      este.loading4 = true;
      const { isEmpty, data } = this.$refs.driverSignature.saveSignature();
      var losdatos = this.$refs.customerSignature.saveSignature();
      var driverBlank = isEmpty || this.isSignatureBlank(this.$refs.driverSignature);
      var customerBlank = losdatos.isEmpty || this.isSignatureBlank(this.$refs.customerSignature);
      var mensaje = {
        color: "red",
        timeout: 5000,
        message: "Please sign and type customer's name before submitting.",
      };
      if (
        driverBlank ||
        customerBlank ||
        este.customerName == "" ||
        este.customerLastName == ""
      ) {
        mensaje = {
          color: "red",
          timeout: 5000,
          message: "Please sign and type customer's name before submitting.",
        };
        este.loading4 = false;
        este.$store.commit("msgMuestra", mensaje);
      } else {
        if (
          [470, 613, 614].includes(este.route.id) &&
          (este.weekly_start == "" ||
            este.weekly_end == "" ||
            este.weekly_mws == "")
        ) {
          mensaje = {
            color: "red",
            timeout: 5000,
            message:
              "Please fill in the weekly manifest data before submitting.",
          };
          este.loading4 = false;
          este.$store.commit("msgMuestra", mensaje);
          return;
        }
        este.driverSignature = data;
        este.customerSignature = losdatos.data;
        // Obtiene location
        // este
        //   .$getLocation()
        //   .then((coordinates) => {
        //     console.log(coordinates);
        //     este.location = coordinates;
        let sendData = {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          driverSignature: este.driverSignature,
          customerSignature: este.customerSignature,
          customerName: este.customerName,
          customerLastName: este.customerLastName,
          // location: este.location,
          routeschedule_id: este.route.routeschedule_id,
          route: este.route.route,
          notes: este.notes,
        };
        if ([470, 613, 614].includes(este.route.id)) {
          sendData.weekly_start = este.weekly_start;
          sendData.weekly_end = este.weekly_end;
          sendData.weekly_mws = este.weekly_mws;
        }
        este.$http
          .post(este.$api + "complete", sendData)
          .then(function (response) {
            console.log(response);
            if (response.status == 200 && response.data.status == "ok") {
              console.log("Route completed.");
              este.editManifestOp = false;
              este.e1 = 5;
              este.driverSignature = "";
              este.customerSignature = "";
              este.customerName = "";
              este.customerLastName = "";
              este.notes = "";
              este.weekly_start = "";
              este.weekly_end = "";
              este.weekly_mws = "";
              este.getExtras();
              este.loading4 = false;
              este.routes[0].customers[este.routeIndex].status = "Completed";
              este.routes[0].customers[este.routeIndex].class = "completed";
              este.routes[0].customers[este.routeIndex].manifestNumber =
                response.data.manifestNumber;
            } else {
              var mensaje = {
                color: "red",
                timeout: 5000,
                message: "There was an error. Please try again.",
              };
              este.loading4 = false;
              este.$store.commit("msgMuestra", mensaje);
            }
          })
          .catch(function (err) {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: "There was an error. Please try again.",
            };
            este.$store.commit("msgMuestra", mensaje);
            este.loading4 = false;
            window.console.log(err);
          });
        // })
        // .catch(function (err) {
        //   var mensaje = {
        //     color: "red",
        //     timeout: 5000,
        //     message: "We couldn't get your location'. Please try again.",
        //   };
        //   este.loading4 = false;
        //   este.$store.commit("msgMuestra", mensaje);
        //   window.console.log(err);
        // });
      }
    },
    closed: function () {
      this.$refs.camera.click();
    },
    addPicture: function () {
      var este = this;
      este.loading5 = true;
      var file = document.querySelector("input[type=file]").files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        window.console.log(e.target.result);
        var image = e.target.result;
        // este
        //   .$getLocation()
        //   .then((coordinates) => {
        //     console.log(coordinates);
        //     este.location = coordinates;
        var laurl = "closed";
        var datos = "";
        datos = {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          routeschedule_id: este.route.routeschedule_id,
          // location: este.location,
          image: image,
          route: este.route.route,
        };
        este.$http
          .post(este.$api + laurl, datos)
          .then(function (response) {
            if (response.status == 200 && response.data.status == "ok") {
              console.log("Closed");
              este.loading5 = false;
              este.routes[0].customers[este.routeIndex].status = "Closed";
              este.routes[0].customers[este.routeIndex].class = "closed";
              este.routes[0].customers[este.routeIndex].image =
                "routeschedules/images/" + este.route.routeschedule_id + ".jpg";
              este.e1 = 5;
              window.console.log(response.status);
            } else {
              var mensaje = {
                color: "red",
                timeout: 5000,
                message: response.data.msg,
              };
              este.$store.commit("msgMuestra", mensaje);
              este.loading5 = false;
              if ("error" in response.data && response.data.error == "logout") {
                este.$router.push("/logout");
              }
            }
          })
          .catch(function (err) {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: "There was an error. Please try again.",
            };
            este.loading5 = false;
            este.$store.commit("msgMuestra", mensaje);
            window.console.log(err);
          });
        // })
        // .catch(function (err) {
        //   var mensaje = {
        //     color: "red",
        //     timeout: 5000,
        //     message: "We couldn't get your location. Please try again.",
        //   };
        //   este.loading5 = false;
        //   este.$store.commit("msgMuestra", mensaje);
        //   window.console.log(err);
        // });
      };
      reader.onerror = function (error) {
        var mensaje = {
          color: "red",
          timeout: 5000,
          message: "There was an error. Please try again.",
        };
        este.loading5 = false;
        este.$store.commit("msgMuestra", mensaje);
        window.console.log(error);
      };
      reader.readAsDataURL(file);
    },
    editManifest: function () {
      var este = this;
      este.loading6 = true;
      // este
      //   .$getLocation()
      //   .then((coordinates) => {
      //     console.log(coordinates);
      //     este.location = coordinates;
      var laurl = "editManifest";
      var datos = "";
      datos = {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
        routeschedule_id: este.route.routeschedule_id,
        // location: este.location,
      };
      este.$http
        .post(este.$api + laurl, datos)
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            este.editManifestOp = true;
            este.loading6 = false;
            console.log("Edit Manifest Ready");
            este.routes[0].customers[este.routeIndex].status = "Check In";
            este.routes[0].customers[este.routeIndex].class = "checkin";
            este.e1 = 3;
            window.console.log(response.status);
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            este.loading6 = false;
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          este.loading6 = false;
          window.console.log(err);
        });
      // })
      // .catch(function (err) {
      //   var mensaje = {
      //     color: "red",
      //     timeout: 5000,
      //     message: "We couldn't get your location. Please try again.",
      //   };
      //   este.loading6 = false;
      //   este.$store.commit("msgMuestra", mensaje);
      //   window.console.log(err);
      // });
    },
    checkIn: function () {
      var este = this;
      este.loading2 = true;
      /*este
        .$getLocation()
        .then((coordinates) => {
          console.log(coordinates);
          este.location = coordinates;*/
      var laurl = "checkIn";
      var datos = "";
      datos = {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
        routeschedule_id: este.route.routeschedule_id,
        // location: este.location,
      };
      este.$http
        .post(este.$api + laurl, datos)
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            este.loading2 = false;
            console.log("Check In Ready");
            este.routes[0].customers[este.routeIndex].status = "Check In";
            este.routes[0].customers[este.routeIndex].class = "checkin";
            este.e1 = 3;
            window.console.log(response.status);
            if (este.hasRouteNotes) {
              este.dialogNote = true;
            }
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            este.loading2 = false;
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          este.loading2 = false;
          window.console.log(err);
        });
      /*})
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "We couldn't get your location. Please try again.",
          };
          este.loading2 = false;
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });*/
    },
    startRoute: function () {
      var este = this;
      este.loading = true;
      // este
      //   .$getLocation()
      //   .then((coordinates) => {
      //     console.log(coordinates);
      //     este.location = coordinates;
      var laurl = "startRoute";
      var datos = "";
      if (este.clockIn == false || este.assignmentVehicle == false) {
        var mensaje = {
          color: "red",
          timeout: 5000,
          message: "Please clock in and assign a vehicle before starting.",
        };
        este.$store.commit("msgMuestra", mensaje);
        este.loading = false;
        return;
      }
      if ("routeschedule_id" in este.route && este.route.routeschedule_id > 0) {
        datos = {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          routeschedule_id: este.route.routeschedule_id,
          // location: este.location,
        };
      } else {
        datos = {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          customer_id: este.route.id,
          pickUpDate: este.date,
          notes: este.route.notes,
          notes_to_driver: este.route.notes_to_driver,
          contactPersonAtClinic: este.route.contactPerson,
          // location: este.location,
        };
      }
      este.$http
        .post(este.$api + laurl, datos)
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            este.loading = false;
            console.log("Route has been started");
            este.routes[0].customers[este.routeIndex].routeschedule_id =
              response.data.routeschedule_id;
            este.routes[0].customers[este.routeIndex].status = "On Route";
            este.routes[0].customers[este.routeIndex].class = "onroute";
            este.e1 = 2;
            window.console.log(response.status);
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg,
            };
            este.$store.commit("msgMuestra", mensaje);
            este.loading = false;
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.loading = false;
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
      // })
      // .catch(function (err) {
      //   var mensaje = {
      //     color: "red",
      //     timeout: 5000,
      //     message: "We couldn't get your location. Please try again.",
      //   };
      //   este.$store.commit("msgMuestra", mensaje);
      //   este.loading = false;
      //   window.console.log(err);
      // });
    },
    muestraRuta: function (index, back = 0) {
      if (back > 0) {
        index = this.routes[0].customers.findIndex((f) => f.id === index);
      }
      if (
        process.env.NODE_ENV == "development" ||
        (this.$store.getters.preTripInspection &&
          this.date <= this.$moment().format("YYYY-MM-DD"))
      ) {
        console.log(this.date);
        console.log(index);
        this.route = this.routes[0].customers[index];
        this.routeIndex = index;
        console.log(this.route);
        this.markers = [
          {
            position: {
              lat: parseFloat(this.route.location[0].lat),
              lng: parseFloat(this.route.location[0].lng),
            },
            title: this.route.businessName,
          },
        ];
        var este = this;
        este.points[index] = {
          location:
            parseFloat(este.route.location[0].lat) +
            "," +
            parseFloat(este.route.location[0].lng),
          stopover: true,
        };
        this.center = {
          lat: parseFloat(este.route.location[0].lat),
          lng: parseFloat(este.route.location[0].lng),
        };
        console.log(this.center);
        this.realStep = 1;
        if ("status" in this.route) {
          switch (this.route.status) {
            case "On Route":
              this.e1 = 2;
              break;
            case "Check In":
              this.e1 = 3;
              break;
            case "Extras / Notes":
              if (this.$route.params.route_back >= 0) {
                this.e1 = 3;
              } else {
                this.e1 = 4;
              }
              break;
            case "Completed":
            case "Closed":
              this.e1 = 5;
              break;
            default:
              this.e1 = 1;
              break;
          }
        } else {
          this.e1 = 1;
        }
        this.dialog = true;
      }
    },
    show: function () {
      var este = this;
      este.$http
        .post(este.$api + "routes", {
          driver_id: este.$store.getters.driver_id,
          token: este.$store.getters.token,
          date: este.date,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.status == "ok") {
            console.log("IMPRIME DATOS");
            window.console.log(response.status);
            if (!response.data.results) {
              este.message = response.data.msg;
              este.routes = [];
            } else {
              este.routes = response.data.data;
              este.id = response.data.id;
              este.optimizeRoute(
                response.data.data.filter((item) => item.customers.length > 0),
              );
              if (este.$store.getters.gotoRoute > -1) {
                //este.muestraRuta(este.$store.getters.gotoRoute);
                este.$store.commit("selectRoute", -1);
                este.$store.commit("customer_id", 0);
                este.$store.commit("route_id", 0);
              }
            }
          } else {
            var mensaje = {
              color: "red",
              timeout: 5000,
              message: response.data.msg,
            };
            este.routes = [];
            este.$store.commit("msgMuestra", mensaje);
            if ("error" in response.data && response.data.error == "logout") {
              este.$router.push("/logout");
            }
          }
        })
        .catch(function (err) {
          este.routes = [];
          var mensaje = {
            color: "red",
            timeout: 5000,
            message: "There was an error. Please try again.",
          };
          este.$store.commit("msgMuestra", mensaje);
          window.console.log(err);
        });
    },
    optimizeRoute: function (route) {
      var este = this;
      este.routes = route;
      setTimeout(function () {
        route.forEach(function (item, index) {
          console.log(item);
          este.initMap(item, index);
        });
      }, 100);
      setTimeout(function () {
        if (este.$route.params.route_back >= 0) {
          este.muestraRuta(este.$route.params.route_back, 1);
        }
      }, 1000);
    },
    initMap: function (route, routeIndex) {
      console.log("Init Map");

      var este = this;

      este.$refs.map.$mapPromise.then((map) => {
        var google = this.google;

        var points = [];
        route.customers.forEach(function (item) {
          points.push({
            lat: parseFloat(item.location[0].lat),
            lng: parseFloat(item.location[0].lng),
          });
        });

        var optimizeWaypoints = false;
        if (route.manualorder > 0) {
          optimizeWaypoints = false;
        }
        console.log(points.length + " puntos en la ruta");
        /* ==========================
           CASO 1: 25 O MENOS → RUTA
        =========================== */
        if (points.length <= 25) {
          var directionsService = new google.maps.DirectionsService();
          var directionsDisplay = new google.maps.DirectionsRenderer({
            suppressMarkers: false,
          });

          directionsDisplay.setMap(map);

          var waypoints = points.map((p) => ({
            location: p.lat + "," + p.lng,
            stopover: true,
          }));

          directionsService.route(
            {
              origin: "33.9190068,-118.1200275",
              destination: "33.9190068,-118.1200275",
              travelMode: "DRIVING",
              waypoints: waypoints,
              optimizeWaypoints: optimizeWaypoints,
            },
            function (response, status) {
              if (status === "OK") {
                if (optimizeWaypoints) {
                  response.routes[0].waypoint_order.forEach(function (it, ind) {
                    este.routes[routeIndex].customers[it].order = ind;
                  });
                }

                este.routes[routeIndex].customers.sort((a, b) =>
                  a.order > b.order ? 1 : -1,
                );

                directionsDisplay.setDirections(response);
                console.log("Ruta pintada con línea azul");
              } else {
                este.$store.commit("msgMuestra", {
                  color: "red",
                  timeout: 5000,
                  message: "Directions failed: " + status,
                });
              }
            },
          );
        } else {
          /* ==========================
           CASO 2: MÁS DE 25 → SOLO PUNTOS
        =========================== */
          var bounds = new google.maps.LatLngBounds();

          points.forEach(function (p, i) {
            var marker = new google.maps.Marker({
              position: p,
              map: map,
              label: String.fromCharCode(65 + (i % 26)),
              title: "Parada " + (i + 1),
            });

            bounds.extend(marker.getPosition());
          });

          // Zoom automático aunque no haya línea
          if (!bounds.isEmpty()) {
            if (points.length > 1) {
              map.fitBounds(bounds);
            } else {
              map.setCenter(bounds.getCenter());
              map.setZoom(14);
            }
          }

          este.routes[routeIndex].customers.sort((a, b) =>
            a.order > b.order ? 1 : -1,
          );

          console.log("Más de 25 puntos: solo markers + zoom");
        }
      });
    },
  },
  mounted: function () {
    var este = this;
    console.log(este.$route.params.route_back);
    window.addEventListener(
      "orientationchange",
      function () {
        if (este.e1 == 4) {
          console.log("Driver Sign");
          este.undoDriver();
          este.driverSign();
        }
      },
      false,
    );
    este.date = this.$moment().format("YYYY-MM-DD");
    //este.date = this.$moment(este.date).subtract(2, 'day').format("YYYY-MM-DD");
    this.$store.commit("title", "Routes");
    var i;
    for (i = 1; i <= 100; i++) {
      this.qtys.push(i);
    }
    console.log("RUTA: ");
    console.log(este.$route.params.route_back);
    if (!this.$store.getters.token || !this.$store.getters.driver_id) {
      this.$router.push("/login");
    } else {
      this.show();
      this.getExtras();
    }
    this.$http
      .post(este.$api + "checkVehicle", {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
      })
      .then((res) => {
        // Verificar que la respuesta sea correcta
        if (res.status === 200 && res.data.status === "ok") {
          if (res.data.results === 1) {
            this.assignmentVehicle = true;
          }
        } else {
          console.error("Error loading vehicles:", res.data.msg || res.data);
        }
      })
      .catch((err) => {
        // Captura errores de la llamada HTTP
        console.error("HTTP error:", err);
      });
    this.$http
      .post(este.$api + "today", {
        driver_id: este.$store.getters.driver_id,
        token: este.$store.getters.token,
      })
      .then((res) => {
        // Verificar que la respuesta sea correcta
        if (res.status === 200 && res.data.status === "ok") {
          if (res.data.data.clockIn === true) {
            this.clockIn = true;
          }
        } else {
          console.error("Error loading vehicles:", res.data.msg || res.data);
        }
      })
      .catch((err) => {
        // Captura errores de la llamada HTTP
        console.error("HTTP error:", err);
      });
  },
};
</script>
